import PropTypes from 'prop-types';
import { Suspense, useEffect } from 'react';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormHelperText, Skeleton } from '@mui/material';
//
import lazyWithReload from '@/routes/lazyWithReload';

// O editor (quill e highlight.js, mais de 1 MB) só baixa quando um formulário com ele
// monta. Importado direto, ele entrava no pacote inicial de toda página pelo barrel
// `components/hook-form`, que o app inteiro importa. Com reload, como as rotas: depois
// de um deploy, o chunk antigo não existe mais.
const Editor = lazyWithReload(() => import('../editor'));

// Área de texto do editor (200 px) mais a barra de ferramentas.
const EDITOR_PLACEHOLDER_HEIGHT = 250;

// ----------------------------------------------------------------------

RHFEditor.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFEditor({ name, helperText, ...other }) {
  const {
    control,
    watch,
    setValue,
    formState: { isSubmitSuccessful },
  } = useFormContext();

  const values = watch();

  useEffect(() => {
    if (values[name] === '<p><br></p>') {
      setValue(name, '', {
        shouldValidate: !isSubmitSuccessful,
      });
    }
  }, [isSubmitSuccessful, name, setValue, values]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Suspense fallback={<Skeleton variant="rounded" height={EDITOR_PLACEHOLDER_HEIGHT} />}>
          <Editor
            id={name}
            value={field.value}
            onChange={field.onChange}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        </Suspense>
      )}
    />
  );
}
